export interface BookingCardTheme {
  key: string;
  name: string;
  gradientFrom: string; // Used as solid background
  gradientTo: string;   // Kept for compatibility
  accentColor: string;
  textPrimary: string;
  textSecondary: string;
  borderColor: string;
}

/**
 * Interface Craft Style Themes
 *
 * Clean, minimal color palettes with:
 * - Solid backgrounds (no gradients)
 * - Clear contrast ratios
 * - Subtle accent colors
 * - Professional polish
 */
export const themesCrafted: Record<string, BookingCardTheme> = {
  midnight_luxe: {
    key: 'midnight_luxe',
    name: 'Night Mode',
    gradientFrom: '#0f0f1a',
    gradientTo: '#0f0f1a',
    accentColor: '#3b82f6',  // Blue
    textPrimary: '#ffffff',
    textSecondary: '#9ca3af',
    borderColor: '#1f2937',
  },
  clean_mono: {
    key: 'clean_mono',
    name: 'Clean Slate',
    gradientFrom: '#ffffff',
    gradientTo: '#ffffff',
    accentColor: '#18181b',  // Near black
    textPrimary: '#09090b',
    textSecondary: '#71717a',
    borderColor: '#e4e4e7',
  },
  warm_gold: {
    key: 'warm_gold',
    name: 'Honey',
    gradientFrom: '#fefce8',
    gradientTo: '#fefce8',
    accentColor: '#ca8a04',  // Gold
    textPrimary: '#713f12',
    textSecondary: '#a16207',
    borderColor: '#fde047',
  },
  soft_stone: {
    key: 'soft_stone',
    name: 'Soft Launch',
    gradientFrom: '#fafaf9',
    gradientTo: '#fafaf9',
    accentColor: '#78716c',  // Warm gray
    textPrimary: '#1c1917',
    textSecondary: '#78716c',
    borderColor: '#e7e5e4',
  },
  electric_edge: {
    key: 'electric_edge',
    name: 'Static',
    gradientFrom: '#0a0a0f',
    gradientTo: '#0a0a0f',
    accentColor: '#06b6d4',  // Cyan
    textPrimary: '#f0f9ff',
    textSecondary: '#67e8f9',
    borderColor: '#164e63',
  },
  gradient: {
    key: 'gradient',
    name: 'Aura',
    gradientFrom: '#FAFAFA',
    gradientTo: '#FAFAFA',
    accentColor: '#111111',
    textPrimary: '#111111',
    textSecondary: 'rgba(0,0,0,0.55)',
    borderColor: 'rgba(0,0,0,0.06)',
  },
  rich_gradient: {
    key: 'rich_gradient',
    name: 'Hyperpop',
    gradientFrom: '#FFF0F8',
    gradientTo: '#FFF0F8',
    accentColor: '#111111',
    textPrimary: '#111111',
    textSecondary: 'rgba(0,0,0,0.55)',
    borderColor: 'rgba(0,0,0,0.06)',
  },
  sky_ripple: {
    key: 'sky_ripple',
    name: 'Sky Ripple',
    gradientFrom: '#E2ECF6',
    gradientTo: '#E2ECF6',
    accentColor: '#C2E4FF',  // Light blue from dithering
    textPrimary: '#1e3a5f',   // Dark blue — light surface; must stay dark for contrast
    textSecondary: '#4a5f7f',
    borderColor: '#B0D4F5',    // Blue border from Paper
  },
};

export function getThemeCrafted(themeKey: string): BookingCardTheme {
  return themesCrafted[themeKey] || themesCrafted.midnight_luxe;
}
